<template>
  <div id="rede-credenciada-empty">
    <div class="content-empty">
      <svg-icone
        v-if="semDescredenciados"
        icone="img_helper_empty_default"
        :width="128"
        :height="128"
        cor="#f6f6f6"
      />
      <div class="icon-circle" v-else>
        <svg-icone
          :icone="funcionalidade.parametros.dashboard.icone"
          :width="64"
          :height="64"
          :cor="esquemaDeCor.aplicacao.corPrimariaAplicacao"
        />
      </div>
      <br>
      <h3>
        {{ title }}
      </h3>
      <p class="paragraph">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RedeDescredenciadaEmpty',
  props: {
    semDescredenciados: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'esquemaDeCor', 'frameId']),
    parametros () {
      return this.funcionalidade.parametros
    },
    title () {
      return this.semDescredenciados ? this.parametros.textos.tituloVazio : this.parametros.textos.tituloIntroducao
    },
    description () {
      return this.semDescredenciados ? this.parametros.textos.textoVazio : this.parametros.textos.textoIntroducao
    }
  }
}
</script>

<style scoped lang="less">
#rede-credenciada-empty {
  .content-empty {
    display: flex;
    flex-direction: column;
    gap: 8px;
    place-items: center;
    padding-top: 150px;
    color: dimgrey;

    .icon-circle {
      background: var(--cor-primaria-aplicacao-transparent);
      border-radius: 100%;
      padding: 16px;
      line-height: 0;
    }

    .paragraph {
      max-width: 350px;
      text-align: center;
    }
  }
}

</style>
